module.exports = __webpack_public_path__ + "static/choker-6900a094611384945b114e0b6b9dc8d8.png";